import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import LogoLibrary from './logo-library';
import AddLogo from './add-logo';
import LogoMatching from './logo-matching';
import { loadLogos } from '../../actions/logos';

class Admin extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tab: 'logo_matching',
    };
  }

  componentDidMount() {
    loadLogos();
  }

  handleTabSelection = ({ target }) => {
    this.setState({ tab: target.id });
  };

  renderTabSelection = (tab) => {
    switch (tab) {
      case 'logo_library':
        return <LogoLibrary />;
      case 'add_logo':
        return <AddLogo onAdd={() => this.setState({ tab: 'logo_library' })} />;
      case 'logo_matching':
        return <LogoMatching />;
      default:
        return null;
    }
  };

  render() {
    const { tab } = this.state;

    return (
      <main className="p-5">
        <Row>
          <Col className="d-flex">
            <h2 className="mb-3 me-5 font-weight-bold">Carrier Logos & Display Names</h2>
            <Nav tabs>
              <NavItem className={`logoTab ${tab === 'logo_library' ? 'logoTabActive' : null}`}>
                <NavLink
                  id="logo_library"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleTabSelection}
                >
                  Logo Library
                </NavLink>
              </NavItem>
              <NavItem className={`logoTab ${tab === 'add_logo' ? 'logoTabActive' : null}`}>
                <NavLink
                  id="add_logo"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleTabSelection}
                >
                  Add Logo
                </NavLink>
              </NavItem>
              <NavItem className={`logoTab ${tab === 'logo_matching' ? 'logoTabActive' : null}`}>
                <NavLink
                  id="logo_matching"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleTabSelection}
                >
                  Logo Matching
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="border bg-white pt-5 h-100 shadow-sm">
              {this.renderTabSelection(tab)}
            </div>
          </Col>
        </Row>
      </main>
    );
  }
}

export default connect()(Admin);
